namespace RioERP.Carts {
    export interface CalculateCartProductRequest extends Serenity.ServiceRequest {
        ProductId?: number;
        CartId?: number;
        Quantity?: number;
        Specification?: number[];
    }
}
